import { Box } from "@braintrust/braintrust-ui-components";

type SpacerProps = {
  width?: string | number;
  height?: string | number;
  className?: string;
};

export const Spacer = ({
  width = "auto",
  height = "auto",
  className,
}: SpacerProps) => {
  return <Box className={className} sx={{ width, height }} />;
};
